import React, { memo } from 'react';

const StarSmall = memo(({ size = 14 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_175_7301)">
        <path
          d="M6.4248 1.52978C6.6697 1.04561 7.33443 1.04561 7.57933 1.52978L8.94378 4.23645C9.03707 4.42311 9.212 4.55145 9.41026 4.59228L12.2908 5.11145C12.8097 5.20478 13.0138 5.86395 12.6465 6.26061L10.6056 8.45395C10.4657 8.60561 10.4015 8.81561 10.4307 9.02561L10.8447 12.0531C10.9205 12.5956 10.384 13.0039 9.91172 12.7589L7.28778 11.4114C7.10702 11.3181 6.89127 11.3181 6.71051 11.4114L4.08657 12.7589C3.61426 12.9981 3.07781 12.5956 3.15362 12.0531L3.56762 9.02561C3.59677 8.81561 3.53263 8.60561 3.39269 8.45395L1.35184 6.26061C0.984492 5.86978 1.19441 5.20478 1.70753 5.11145L4.58804 4.59228C4.78629 4.55728 4.96122 4.42311 5.05452 4.23645L6.41896 1.52978H6.4248Z"
          stroke="#5A5A5A"
          strokeMiterlimit="10"
        />
      </g>
      <defs>
        <clipPath id="clip0_175_7301">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
});

export default StarSmall;
